import { render, staticRenderFns } from "./GiftCustomizationMode.vue?vue&type=template&id=70aab836&"
import script from "./GiftCustomizationMode.vue?vue&type=script&lang=js&"
export * from "./GiftCustomizationMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports